// extracted by css-extract-rspack-plugin
export default {"toolbar":"toolbar-B6Ijzv","table":"table-ge0y_s"};